import { createWalletBindingApi2 } from '../../api/create-wallet-binding-v2';
import { ApiHost, BindWalletOptionsV2, PaymentFrameEventsV2 } from '../../types';
import { paymentForm } from '../payment-form';

export const bindWalletV2 = async (apiHost: ApiHost, options: BindWalletOptionsV2) => {
    const url = await createWalletBindingApi2(apiHost, options);

    return paymentForm<PaymentFrameEventsV2>(apiHost, { url });
};
